import { render, staticRenderFns } from "./KardexPhysical.vue?vue&type=template&id=1fba2170&"
import script from "./KardexPhysical.vue?vue&type=script&lang=js&"
export * from "./KardexPhysical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports